import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'menu',
})
export class MenuPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter && items) {

      if (filter['modulo'] > 0) {

        items = items.filter(function (item) {
          return item.modulo == filter['modulo'];
        });
      }

      if (filter['only']) {

        items = items.filter(function (item) {
          return item.only.length == 0 || item.only.includes(parseInt(filter['only']));
        });
      }

      if (true) {

        return items.sort((a, b) => b['permisos'] - a['permisos']);
      }
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/menu/menu.ts